import { DOCUMENT_TYPES } from '../../constants/purchase';
import { PurchaseFormValues } from '../../types/purchases/BasePurchase';

// Interface base para todos
interface PurchaseUpdatePayload {
  id: number;
  documentNumber: string;
  purchaseDate: string;
  documentType: { id: number };
  supplier: { id: number };
  comments?: string;
  // Solo para otros documentos (no importación ni NC)
  creditDueDate?: string;
  paymentConditionId?: number;
  creditDays?: number;
  // Solo para importación
  totalQuantity?: number;
  netAmount?: number;
  freight?: number;
  insurance?: number;
  fauca?: number;
  otherCosts?: number;
  totalCost?: number;
}

export const mapPurchaseToUpdateDTO = (
  form: PurchaseFormValues
): PurchaseUpdatePayload => {
  const documentTypeId = form.documentType?.id;

  if (!documentTypeId) {
    throw new Error('❌ El tipo de documento es obligatorio');
  }

  switch (documentTypeId) {
    case DOCUMENT_TYPES.IMPORT:
      return mapImportUpdateDTO(form);

    case DOCUMENT_TYPES.CREDIT_NOTE:
      return mapCreditNoteUpdateDTO(form);

    case DOCUMENT_TYPES.TAX_CREDIT:
    case DOCUMENT_TYPES.DEBIT_NOTE:
    case DOCUMENT_TYPES.EXCLUDED_SUBJECT:
    case DOCUMENT_TYPES.INVOICE:
    case DOCUMENT_TYPES.TICKET:
      return mapStandardUpdateDTO(form);

    default:
      throw new Error('❌ Tipo de documento no soportado para actualización.');
  }
};

// 🛳️ Mapper para actualización de importaciones
const mapImportUpdateDTO = (form: PurchaseFormValues): PurchaseUpdatePayload => ({
  id: form.id!,
  documentNumber: form.documentNumber!,
  purchaseDate: form.purchaseDate!,
  documentType: { id: form.documentType!.id },
  supplier: { id: form.supplier!.id },
  comments: form.comments?.trim() || '',
  totalQuantity: form.totalQuantity || 0,
  netAmount: form.netAmount || 0,
  freight: form.freight || 0,
  insurance: form.insurance || 0,
  fauca: form.fauca || 0,
  otherCosts: form.otherCosts || 0,
  totalCost: form.totalCost || 0,
});

// ✍️ Mapper específico para Nota de Crédito
const mapCreditNoteUpdateDTO = (form: PurchaseFormValues): PurchaseUpdatePayload => ({
  id: form.id!,
  documentNumber: form.documentNumber!,
  purchaseDate: form.purchaseDate!,
  documentType: { id: form.documentType!.id },
  supplier: { id: form.supplier!.id },
  comments: form.comments?.trim() || '',
});

// 📄 Mapper para actualización de otros documentos
const mapStandardUpdateDTO = (form: PurchaseFormValues): PurchaseUpdatePayload => {
  const dto: PurchaseUpdatePayload = {
    id: form.id!,
    documentNumber: form.documentNumber!,
    purchaseDate: form.purchaseDate!,
    documentType: { id: form.documentType!.id },
    supplier: { id: form.supplier!.id },
    comments: form.comments?.trim() || '',
  };

  if (form.paymentCondition?.id) {
    dto.paymentConditionId = form.paymentCondition.id;
  }

  if (form.creditDays && +form.creditDays > 0) {
    dto.creditDays = +form.creditDays;
  }

  if (form.creditDueDate) {
    dto.creditDueDate = form.creditDueDate;
  }

  return dto;
};
